/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import { RichText } from "@simplicitycms/simplicity-richtext";
import { LoginSignupModal } from "components/call-to-action-subscribe/login-signup-modal";
// import { Redirect } from 'react-router-dom';
// import { CTAImage } from '../../../cms/components/call-to-action/cta-image';
// import { WhenSignedIn } from '../sign-in/sign_in_out_util';

const CTAHorizontalDevApps = () => {
    // const image = props?.image;
    // const settings = props?.settings;

    const isAuthenticated = useIsAuthenticated();
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

    const handleModal = (isOpen) => {
        setIsLoginModalOpen(isOpen);
    };

    const navigate = useNavigate();

    const linkClick = () => {
        if (isAuthenticated) {
            navigate("/myDNV");
        } else {
            // set localStorage key for redirecting to myDNV
            localStorage.setItem("dev-app-redirect", "true");
            setIsLoginModalOpen(true);
        }
    };

    useEffect(() => {
        if (
            localStorage.getItem("dev-app-redirect") === "true" &&
            localStorage.getItem("signin-redirect-action") === "subscribe"
        ) {
            localStorage.removeItem("dev-app-redirect");
            localStorage.removeItem("signin-redirect-action");
            navigate("/myDNV");
        }
    });

    return (
        <div className='dev-apps-cta'>
            <h2>Stay up-to-date on local development proposals</h2>
            <div className={`simplicity-cta-container horizontal`}>
                <div
                    className='simplicity-cta-content-image horizontal'
                    title='An aerial view of homes at the base of the mountains on the north shore'
                    style={{
                        backgroundImage: 'url("https://dnv-stage-images.simplicitycms.ca/images/north-shore-aerial-med.jpg")',
                        backgroundPosition: "center center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                    }}
                ></div>

                <div className={`simplicity-cta-content horizontal`}>
                    <div className='cta-title'>
                        {isAuthenticated && (
                            <NavLink to='/myDNV'>Subscribe to new significant development applications</NavLink>
                        )}

                        {!isAuthenticated && (
                            <button
                                className='btn btn-link notLoggedInBtn'
                                onClick={() => {
                                    linkClick();
                                }}
                            >
                                Subscribe to new significant development applications
                            </button>
                        )}
                    </div>

                    <RichText
                        richtext={
                            "Get notified when we receive new major development applications in your neighbourhood or across the District."
                        }
                    />
                </div>
            </div>
            <LoginSignupModal isOpen={isLoginModalOpen} setModalOpen={handleModal} action={"subscribe"} />
        </div>
    );
};

CTAHorizontalDevApps.displayname = "CTAHorizontal - Dev Apps";
export { CTAHorizontalDevApps };
